import { Monitor, Moon, Sun } from 'lucide-react'
import { useThemeStore } from '@/store/themeStore'
import { ThemePreference } from '@/lib/theme'

const NEXT: Record<ThemePreference, ThemePreference> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
}

const LABEL: Record<ThemePreference, string> = {
  system: 'Тема: как в системе',
  light: 'Тема: светлая',
  dark: 'Тема: тёмная',
}

const ICON = {
  system: Monitor,
  light: Sun,
  dark: Moon,
} as const

interface ThemeToggleProps {
  className?: string
}

/**
 * Переключатель темы: system → light → dark → system.
 *
 * Три состояния, а не два: франчайзи работают и внутри Telegram (там тему
 * задаёт клиент), и в обычном браузере. Режим `system` следует за платформой,
 * явный выбор её перебивает.
 */
export function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const preference = useThemeStore((state) => state.preference)
  const resolved = useThemeStore((state) => state.resolved)
  const setPreference = useThemeStore((state) => state.setPreference)

  const Icon = ICON[preference]
  const title =
    preference === 'system' ? `${LABEL.system} (сейчас ${resolved === 'dark' ? 'тёмная' : 'светлая'})` : LABEL[preference]

  return (
    <button
      type="button"
      onClick={() => setPreference(NEXT[preference])}
      className={`flex items-center justify-center w-8 h-8 rounded-lg bg-muted/60 hover:bg-muted transition-colors ${className}`}
      title={title}
      aria-label={title}
    >
      <Icon className="w-4 h-4 text-muted-foreground" />
    </button>
  )
}

export default ThemeToggle
